export default __webpack_public_path__ + "static/media/Artboard 2.8dddad56.png";